import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';
import moment from 'moment';

@Component({
    selector: 'input-time',
    templateUrl: './input.time.html',
    styleUrls: ['./input.scss'],
    providers: [
        { 
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InputTime),
          multi: true
        }
      ],
      // changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputTime implements OnInit, OnChanges, ControlValueAccessor {

    value: Date | moment.Moment;

    timeString: string;

    @Input('name')
    name: string;

    @Input('label')
    label: string;

    @Input('hint')
    hint: string;

    @Input('error-message')
    errorMessage: string;

    @Input('required')
    required: boolean;

    @Input('hidden')
    hidden: boolean;

    @Input('disabled')
    disabled: boolean;

    @Input('readonly')
    readonly: boolean;

    @Input('validator')
    validator: (string) => string; 

    @Input('min')
    min: string;

    @Input ('max')
    max: string;

    error: string;

    minTime: string;
    maxTime: string;

    // control: FormControl;

    ngOnInit() {
      this.timeString = this.getTimeString();
      // this.required = true;
      // this.control = new FormControl(this.value);

      // if (this.required) { this.control.setValidators([Validators.required]); }
      // if (this.disabled) { this.control.disable(); }
    }

    ngOnChanges(changes: SimpleChanges) {
      this.timeString = this.getTimeString();
    }

    setTimeString(time: string) {
      if (!this.value) {
        this.value = new Date();
      } //else {
        //this.value = new Date(this.value);
      //}
      if (typeof(this.value) == 'string') this.value = moment(this.value);

      let all = time.split(' ');
      let parts = all[0].split(':');
  
      let noon = (all[1].toLowerCase() == 'pm') ? 12 : 0;
      let hrs = +parts[0];
      hrs = (hrs < 12)? hrs + +noon : (hrs % 24);
      let mins = +parts[1];
  
      if (moment.isMoment(this.value)) {
        this.value.set('hour', hrs).set('minute', mins);
      } else
        try {
          this.value.setHours(hrs);
          this.value.setMinutes(mins);
        } catch(jsError) {
      }
      this.changeValue(this.value);
      // console.log("New start time:", this.event.ends);
    }
  
    getTimeString(): string {
      if (!this.value) return null;

      if (moment.isMoment(this.value)) {
        return this.value.get('hour') + ':' + this.value.get('minute');
      } else {
        let src = new Date(this.value);
        return src.getHours() + ':' + src.getMinutes(); 
      }
    }

  //   setupTimeRange(date: Date) {
  //     let today = new Date();
  //     if (date.getFullYear() == today.getFullYear() && date.getMonth() == today.getMonth() && date.getDate() == today.getDate()) {
  //         let hrs = today.getHours();
  //         let mins = today.getMinutes();
  //         let ampm = (hrs > 12)? ' pm' : ' am';
  //         hrs = (hrs > 12)? hrs - 12 : hrs;
  //         this.minTime = this.padZeros(hrs) + ':' + this.padZeros(mins) + ampm;
  //     }
  //     this.maxTime = '11:59 pm';
  // }

  // padZeros(n: number, len: number=2) {
  //     let str = '' + n;
  //     for(let i=0; i<len - n.toString().length; i++) {
  //         str = '0' + str;
  //     }
  //     return str;
  // }


    readonly errorMatcher: ErrorStateMatcher = {
      isErrorState: (ctrl: FormControl) => {
          // (ctrl && ctrl.invalid)
          // this.error = null;
          // if (this.required && (!this.value || this.value.trim().length == 0)) {
          //     this.error = 'required';
          // }
          return !!this.error;
        }
    }

    changeValue(event: Date | moment.Moment) {
      this.value = event;

      if (moment.isMoment(event)) {
        this.value = moment(event);
        this.value.set('hour', event.get('hour')).set('minute', event.get('minute'));
      } else {
        this.value = new Date(event);
      }
      this.propagateChange(this.value);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }

      this.error = null;
      if (this.required && !event) {
        this.error = 'Value is required';
      }
    }

    writeValue(value: any) {
      // if (value !== undefined) {
        // if (value != this.value) {
          // this.changeValue(value);
        // }
        this.value = value;
        this.timeString = this.getTimeString();
      // }
    }

    propagateChange = (_: Date | moment.Moment) => {};

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {}
}